import { toast } from "react-toastify";
import i18n from "../i18n"; 

export const handleApiError = (e) => {
  const errorData = e.response?.data?.error;
  if (!errorData) {
    toast.error(e.message || "Unknown error");
    return;
  }

  const currentLang = i18n.language || "ar";

  if (currentLang === "ar" && errorData.message_AR) {
    toast.error(errorData.message_AR);
  } else if (currentLang === "en" && errorData.message_EN) {
    toast.error(errorData.message_EN);
  } else {
    toast.error(
      errorData.message_AR || errorData.message_EN || "Unknown error",
    );
  }
};
